import { render, staticRenderFns } from "./KpiTile.vue?vue&type=template&id=52951d10&scoped=true&"
import script from "./KpiTile.vue?vue&type=script&lang=js&"
export * from "./KpiTile.vue?vue&type=script&lang=js&"
import style0 from "./KpiTile.vue?vue&type=style&index=0&id=52951d10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52951d10",
  null
  
)

export default component.exports